<template>
  <div id="sideBar">
    <div id="vehicule-info-container">
      <div id="selected-vehicle-info">
        <SelectFleet class="fleet-selector" :update="update" />
        <div
          v-if="getVehicles.length > 0"
          id="circle"
          :class="{
            active: getCurrentVehicle.status === 'INSTANT_CHARGING',
          }"
        >
          <img
            v-if="getCurrentVehicle.status === 'INSTANT_CHARGING'"
            src="./../assets/picto-EV 2.svg"
            alt="car"
          />
          <img v-else src="./../assets/picto-EV 2 blue.svg" alt="car-charged" />
        </div>
        <h4
          v-if="getVehicles.length > 0"
          id="selected-vehicle-title"
          :class="{
            'active-title': getCurrentVehicle.status === 'INSTANT_CHARGING',
          }"
        >
          {{ getCurrentVehicle.name }}
        </h4>
        <boost-button
          v-if="getVehicles.length > 0 && getCurrentVehicle.currentTransaction"
          :idVehicle="getCurrentVehicle.id"
          :idTransaction="
            getCurrentVehicle.currentTransaction
              ? getCurrentVehicle.currentTransaction.id
              : null
          "
          :disable="isEvseConnect"
          :activated="getCurrentVehicle.status === 'INSTANT_CHARGING'"
        ></boost-button>
        <div v-else id="boost-spacer"></div>
        <h4 v-if="getVehicleList.length > 0" id="other-vehicle-txt">
          {{ $t("side-menu.other-vehicles") }}
        </h4>
      </div>
    </div>
    <div id="vehicle-list" v-if="getVehicleList.length > 0">
      <div
        v-for="vehicle of getVehicleList"
        v-bind:key="vehicle.id"
        @click="changeVehicule(vehicle)"
        class="item-hover"
      >
        <div class="list-item">
          <img
            src="./../assets/picto-EV 3.svg"
            alt="car"
            class="svg-vehicle-list"
          />
          <div class="list-item-text">
            {{ vehicle.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectFleet from '../components/select-fleet'
import BoostButton from '../components/boost-button'
export default {
  props: {
    update: { type: Function, required: true }
  },
  components: { BoostButton, SelectFleet },
  computed: {
    ...mapGetters('vehicle', ['getVehicles', 'getCurrentVehicle', 'getEvses']),
    getVehicleList () {
      return this.getVehicles.filter((val) => this.getCurrentVehicle.id !== val.id).sort((a, b) => a.name.localeCompare(b.name))
    },
    isEvseConnect () {
      const evsesOccupied = this.getEvses.filter(evse => evse.currentTransaction)
      if (evsesOccupied && this.getCurrentVehicle.currentTransaction) {
        for (const evse of evsesOccupied) {
          if (evse.currentTransaction.id === this.getCurrentVehicle.currentTransaction.id && evse.status === 'DISCONNECTED') {
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions('vehicle', ['setVehicle']),
    async changeVehicule (vehicle) {
      await this.setVehicle(vehicle)
      this.update()
    }
  }
}
</script>

<style>
.svg-vehicle-list {
  margin-right: 10px;
}

.list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 57px;
  padding-bottom: 6px;
  padding-top: 6px;
  cursor: pointer;
}

.item-hover:hover {
  background-color: white;
}

.v-input__slot {
  background-color: white !important;
}

.list-item-text {
  color: #10367a;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
}

.fleet-selector {
  margin-top: 10px;
}

#vehicule-info-container {
  width: 255px;
}

#sideBar {
  background-color: rgba(16, 137, 255, 0.1);
  width: 324px;
  height: calc(100vh - 100px);
}

#selected-vehicle-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

#circle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 100px;
  height: 100px;
  background-color: white;
  border-radius: 50%;
  border-width: 2px;
  border: solid #10367a;
}

#circle.active {
  border: solid #fe5815;
}

#selected-vehicle-title {
  margin-top: 6px;
  font-size: 14px;
  color: #10367a;
}

#selected-vehicle-title.active-title {
  color: #fe5815;
}

#boost-spacer {
  height: 20px;
  width: 1px;
}

#other-vehicle-txt {
  margin-top: 54px;
  margin-bottom: 28px;
  color: #10367a;
  font-size: 14px;
  font-weight: 500;
}

#vehicle-list {
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 346px - 100px);
}

/* customize scrollbar css */
#vehicle-list::-webkit-scrollbar {
  width: 11px;
  background-color: rgba(16, 136, 255, 0);
}
#vehicle-list::-webkit-scrollbar:horizontal {
  height: 11px;
}
#vehicle-list::-webkit-scrollbar-track {
  border: 1px rgba (16, 137, 255, 0.1) solid;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 6px rgba(16, 136, 255, 0) inset;
  box-shadow: 0px;
}
#vehicle-list::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border: 1px solid #10367a;
  border-radius: 16px;
}
</style>
